<template>
  <Popup ref="termsCondition" :title="popupTitle" :content="popupContent"/>
</template>

<script>
import Popup from '@/components/Popup'
export default {
  name: 'RegistrationData',
  components: {
    Popup
  },
  data() {
    return {
      popupContent: this.$store.state.promoData.note,
      popupTitle: '',
    }
  },
  watch: {
    '$store.state.promoData.note': function() {
      this.popupContent = this.$store.state.promoData.note
    }
  },
  methods: {
    gotoModifyCode() {
      this.$store.commit('toggleShowProductData');
      this.$store.commit('hidePromoData');
    },
    gotoLink() {
      window.open(this.$store.state.prodRegLink, '_blank');
    },
    openPopupTerms (){
      this.$refs.termsCondition.open()
    }
  },
}
</script>